var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.renderId, staticClass: "dynamic-quick-reply-message-editor" },
    [
      _c(
        "div",
        { staticClass: "mb-2 w-100" },
        [
          _c(
            "div",
            {
              staticClass: "mb-1",
              staticStyle: { color: "#475e7a", "font-weight": "600" },
            },
            [_vm._v("Data Source:")]
          ),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: {
              placeholder: "Enter data source attribute",
              "show-attributes": true,
              "whatsapp-mode": false,
              "allowed-attributes": _vm.allowedAttributes,
              "preview-mode": _vm.previewMode,
            },
            model: {
              value: _vm.clone.dataSource,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "dataSource", $$v)
              },
              expression: "clone.dataSource",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("TiptapEditor", {
        attrs: {
          placeholder: _vm.$t("chatbotv2.enterYourMessage"),
          "show-attributes": _vm.showAttributes,
          "show-emoji": _vm.showEmoji,
          "max-character-count": 640,
          "whatsapp-mode": _vm.whatsappMode,
          "allowed-attributes": _vm.allowedAttributes,
          "show-emoji-picker": _vm.showEmojiPicker,
        },
        model: {
          value: _vm.clone.message,
          callback: function ($$v) {
            _vm.$set(_vm.clone, "message", $$v)
          },
          expression: "clone.message",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "quick-replies" }, [
        _c(
          "div",
          { staticClass: "quick-reply" },
          [
            _c(
              "a-popover",
              {
                attrs: {
                  visible: _vm.editingButtonPopupVisible,
                  placement: "left",
                  trigger: "click",
                  overlayClassName: "no-padding",
                },
                on: { visibleChange: _vm.visibleChange },
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "content" }, slot: "content" },
                  [
                    _c("ActionButtonUpdater", {
                      attrs: {
                        "on-completed": _vm.onButtonUpdateCompleted,
                        "popup-visible": _vm.editingButtonPopupVisible,
                        flattedDiagram: _vm.flattedDiagram,
                        "whatsapp-mode": _vm.whatsappMode,
                        "allowed-attributes": _vm.allowedAttributes,
                        "dynamic-button-message-editor": true,
                        allowedMessageTypes: ["SEND_MESSAGE"],
                      },
                      model: {
                        value: _vm.clone.buttonTemplate,
                        callback: function ($$v) {
                          _vm.$set(_vm.clone, "buttonTemplate", $$v)
                        },
                        expression: "clone.buttonTemplate",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "quick-reply-text" }, [
                  _vm._v(_vm._s(_vm.clone.buttonTemplate.title)),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }